export class NumeroUtils {

  public static desformatar(v: string) {     
    return (!v) ? v : v.replace(/\D/g, ''); // Remove tudo o que e digito      
  }

  public static toString(v: number): string {
    if (!v && v !== 0) return '';
    return v.toString();
  }

  public static calcularDigito(v: string, peso: number[]): string {
    let soma = 0;
    for (let indice = v.length - 1, digito; indice >= 0; indice--) {
      // CNPJ alfanumérico: valor = ASCII(char) - 48 ('0'-'9' => 0-9; 'A'-'Z' => 17-42)
      digito = v.charCodeAt(indice) - 48;
      soma += digito * peso[peso.length - v.length + indice];
    }
    soma = 11 - soma % 11;
    return soma > 9 ? '0' : soma.toString();
  }
}
